import { useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { useCitaEditar } from './hooks/useCitaEditar';

import { useForm, useFormValidation } from '../../../hooks';

import { PrimaryButton, LightButton, DateInput, TimeInput, TextAreaInput, TextInput, Forbidden } from '../../../components';

import styles from '../Modals.module.css';

export const EditarEventoModal = ({ cita = null, hide }) => {

    const { permisos } = useSelector(state => state.auth);

    const [inactivoFlag, setInactivoFlag] = useState(false);
    const [horarioFlag, setHorarioFlag] = useState(false);
    const [empalmadaFlag, setEmpalmadaFlag] = useState(false);

    const activeInactivoFlag = () => {
        setInactivoFlag(true);
    }

    const activeHorarioFlag = () => {
        setHorarioFlag(true);
    }

    const activeEmpalmadaFlag = () => {
        setEmpalmadaFlag(true);
    }

    const { updateCitaMutation: { mutate: updateCita } } = useCitaEditar();

    const { nombre, fechaInicio, horaInicio, fechaFin, horaFin, comentario, onInputChange, onResetForm } = useForm({ nombre: (typeof cita.nombre !== 'undefined') ? cita.nombre : '', fechaInicio: (cita !== null) ? cita.diaSinFormato : '', horaInicio: (cita !== null) ? cita.horaSinFormato : '', fechaFin: (cita !== null) ? cita.diaSinFormatoFin : '', horaFin: (cita !== null) ? cita.horaSinFormatoFin : '', comentario: (cita !== null) ? cita.comentario : '' });

    const { isFormValid, formValidationStatus, formFields, startFormValidation, setFormFieldValidation, onResetValidation } = useFormValidation([{field: 'nombre', default: true}, {field: 'fechaInicio', default: (cita !== undefined) ? true : false}, {field: 'horaInicio', default: (cita !== undefined) ? true : false}, {field: 'fechaFin', default: (cita !== undefined) ? true : false}, {field: 'horaFin', default: (cita !== undefined) ? true : false}, {field: 'comentario', default: true}]);

    const handleInputChange = (e) => {
        setInactivoFlag(false);
        setHorarioFlag(false);
        setEmpalmadaFlag(false);
        onInputChange(e);
    }

    const handleSuccessSubmit = () => {
        onResetForm();
        onResetValidation();
    }

    const onSubmit = async ( event ) => {
        event.preventDefault();

        if(formValidationStatus === 'checked' && isFormValid != null && isFormValid){
            
            updateCita({ id: cita._id, data: { nombre, fechaInicio, horaInicio, fechaFin, horaFin, comentario, inactivoConfirmacion: inactivoFlag, horarioConfirmacion: horarioFlag, empalmadaConfirmacion: empalmadaFlag }, onSuccess: handleSuccessSubmit, onComplete: hide, onInactivo: activeInactivoFlag, onHorario: activeHorarioFlag, onEmpalmada: activeEmpalmadaFlag});

        }else{

            startFormValidation();

        }

    }

    return (permisos.eventoUpdate) ? (
        <>
            <div>
                <form onSubmit={ onSubmit }>
                    <div className="row mb-3">
                        <div className="col">
                            <div className={styles.modalHeader}>Editar evento</div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <TextInput
                                formFieldStatus={ formFields['nombre'].status }
                                label="Nombre(s)"
                                name="nombre"
                                onChange={ onInputChange }
                                required={ true }
                                requiredIndicator={ true }
                                setFormFieldValidation={ setFormFieldValidation }
                                value={ nombre }
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6 col-lg-3">
                            <DateInput
                                formFieldStatus={ formFields['fechaInicio'].status }
                                label="Desde"
                                name="fechaInicio"
                                onChange={ handleInputChange }
                                required={ true }
                                requiredIndicator={ true }
                                setFormFieldValidation={ setFormFieldValidation }
                                value={ fechaInicio }
                            />
                        </div>
                        <div className="col-md-6 col-lg-3">
                            <TimeInput
                                formFieldStatus={ formFields['horaInicio'].status }
                                label=""
                                name="horaInicio"
                                onChange={ handleInputChange }
                                required={ true }
                                requiredIndicator={ false }
                                setFormFieldValidation={ setFormFieldValidation }
                                value={ horaInicio }
                            />
                        </div>
                        <div className="col-md-6 col-lg-3">
                            <DateInput
                                formFieldStatus={ formFields['fechaFin'].status }
                                label="Desde"
                                name="fechaFin"
                                onChange={ handleInputChange }
                                required={ true }
                                requiredIndicator={ true }
                                setFormFieldValidation={ setFormFieldValidation }
                                value={ fechaFin }
                            />
                        </div>
                        <div className="col-md-6 col-lg-3">
                            <TimeInput
                                formFieldStatus={ formFields['horaFin'].status }
                                label=""
                                name="horaFin"
                                onChange={ handleInputChange }
                                required={ true }
                                requiredIndicator={ false }
                                setFormFieldValidation={ setFormFieldValidation }
                                value={ horaFin }
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col">
                            <TextAreaInput
                                formFieldStatus={ formFields['comentario'].status }
                                label="Comentario"
                                name="comentario"
                                onChange={ handleInputChange }
                                required={ false }
                                requiredIndicator={ false }
                                setFormFieldValidation={ setFormFieldValidation }
                                value={ comentario }
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col">
                            {(inactivoFlag) && <p className={styles.helperErrorText}>La fecha seleccionada esta marcada como día inactivo en la configuración del consultorio. ¿Deseas continuar igualmente?</p>}
                            {(horarioFlag) && <p className={styles.helperErrorText}>El periodo de tiempo seleccionado esta fuera del horario configurado para el consultorio. ¿Deseas continuar igualmente?</p>}
                            {(empalmadaFlag) && <p className={styles.helperErrorText}>El periodo de tiempo seleccionado se empalma con otra cita previamente agendada. ¿Deseas continuar igualmente?</p>}
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xs-12 col-sm-12 col-md-6">
                            <LightButton
                                block={true}
                                icon="X"
                                marginTop={false}
                                onClick={ hide }
                                text="Cancelar"
                                type="button"
                            />
                        </div>
                        <div className='col-xs-12 col-sm-12 col-md-6'>
                            <PrimaryButton
                                block={true}
                                disabled={formValidationStatus === 'checking'}
                                icon="Check"
                                marginTop={false}
                                text="Editar"
                                type="submit"
                            />
                        </div>
                    </div>
                </form>
            </div>
        </>
    ) : <Forbidden />
}

EditarEventoModal.propTypes = {
  cita: PropTypes.object,
  hide: PropTypes.func.isRequired,
}